document.addEventListener('DOMContentLoaded', function () {

  const sliders = document.querySelectorAll('.premium-testimonials-swiper');

  sliders.forEach((slider) => {

    const swiper = new Swiper(slider, {
      loop: true,

      speed: 1200,

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },

      spaceBetween: 20,

      slidesPerView: 1.25,

      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      },

      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true
      },

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      }

    });

    slider.addEventListener('mouseenter', () => {
      swiper.autoplay.stop();
    });

    slider.addEventListener('mouseleave', () => {
      swiper.autoplay.start();
    });

  });

});